module.exports = __webpack_public_path__ + "img/red_060.83fe1d24.png";